export default {
  name: "dr-header"
};
